export { default } from "./CMSBanner";
